import Vue from 'vue'
import Router from 'vue-router'
import nullPage from '../src/views/nullPage'
import main from '../src/main.vue'
import login from '../src/views/login'
import home from '../src/views/home'
import register from '../src/views/register'
import password from '../src/views/password'
import project from '../router/childRoute/project'
import approval from '../router/childRoute/approval'
import setting from '../router/childRoute/setting'
import data from '../router/childRoute/data'
import archives from '../router/childRoute/archives'
import bigData from '../router/childRoute/bigData'
import knowledge from '../router/childRoute/knowledge'
import createTest from '@/views/project/createTest'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path:'',
      component:main,
      children:[
        {path: '/', name: 'home', component: home,meta:{title:companyName+'互联网律所 - 首页'},},
        {path: '/createTest', name: 'createTest', component: createTest,meta:{title:companyName+'互联网律所 - 合同内容填写'},},
        //项目管理路由
        {
          path: '/project',
          component: nullPage,
          children:[
            {path: 'list', name: 'projectList', component: project.list,meta:{title:companyName+' - 案件列表'},},
            {path: 'details',
              component: project.details.mdPage,
              children:[
                {path:'task',name:'projectTask',component:project.details.task,meta:{title:companyName+' - 案件 - 任务'}},
                {path:'situation',name:'projectSituation',component:project.details.situation,meta:{title:companyName+' - 案件 - 案情'}},
                {path:'approval',name:'projectApproval',component:project.details.approval,meta:{title:companyName+' - 案件 - 审批'}},
                {path:'comment',name:'projectComment',component:project.details.comment,meta:{title:companyName+' - 案件 - 评论'}},
                {path:'history',name:'projectHistory',component:project.details.history,meta:{title:companyName+' - 案件 - 操作记录'}},
                {path:'receivables',name:'projectReceivables',component:project.details.receivables,meta:{title:companyName+' - 案件 - 收款'}},
                {path:'statistics',name:'projectStatistics',component:project.details.statistics,meta:{title:companyName+' - 案件 - 统计'}},
                {path:'seal',name:'projectSeal',component:project.details.seal,meta:{title:companyName+' - 案件 - 盖章'}},
                {path:'setting',name:'projectSetting',component:project.details.setting,meta:{title:companyName+' - 案件 - 设置'}},
              ],
            },
            {
              path:'contract',
              component:nullPage,
              children:[
                {
                  path:'adviser',
                  component:nullPage,
                  children:[
                    {path:'civil',name:'projectContractAdviserCivil',component:project.contract.adviser.civil,meta:{title:companyName+' - 案件 - 合同文件'}},
                    {path:'administration',name:'projectContractAdviserAdministration',component:project.contract.adviser.administration,meta:{title:companyName+' - 案件 - 合同文件'}},
                    {path:'criminal',name:'projectContractAdviserCriminal',component:project.contract.adviser.criminal,meta:{title:companyName+' - 案件 - 合同文件'}},
                  ]
                },
                {
                  path:'litigation',
                  component:nullPage,
                  children:[
                    {path:'file',name:'projectContractLitigation',component:project.contract.litigation.file,meta:{title:companyName+' - 案件 - 合同文件'}},
                  ]
                },
                {
                  path:'special',
                  component:nullPage,
                  children:[
                    {path:'file',name:'projectContractSpecial',component:project.contract.special.file,meta:{title:companyName+' - 案件 - 合同文件'}},
                  ]
                },
              ],
            },
            {
              path: 'create',
              component: project.create.mdPage,
              children:[
                {
                  path: 'adviser',
                  component: nullPage,
                  children:[
                    {path: 'step1',name: 'adviserStep1', component:project.create.adviser.step1,meta:{title:companyName+' - 新建案件 - 基础信息填写'},},
                    {path: 'step2',name: 'adviserStep2', component:project.create.adviser.step2,meta:{title:companyName+' - 新建案件 - 利冲报告'},},
                    {path: 'step3',name: 'adviserStep3', component:project.create.adviser.step3,meta:{title:companyName+' - 新建案件 - 完善信息'},},
                  ]
                },
                {
                  path: 'special',
                  component: nullPage,
                  children:[
                    {path: 'step1',name: 'specialStep1', component:project.create.special.step1,meta:{title:companyName+' - 新建案件 - 基础信息填写'},},
                    {path: 'step2',name: 'specialStep2', component:project.create.special.step2,meta:{title:companyName+' - 新建案件 - 利冲报告'},},
                    {path: 'step3',name: 'specialStep3', component:project.create.special.step3,meta:{title:companyName+' - 新建案件 - 完善信息'},},
                  ]
                },
                {
                  path: 'litigation',
                  component: nullPage,
                  children:[
                    {path: 'step1',name: 'litigationStep1', component:project.create.litigation.step1,meta:{title:companyName+' - 新建案件 - 基础信息填写'},},
                    {path: 'step2',name: 'litigationStep2', component:project.create.litigation.step2,meta:{title:companyName+' - 新建案件 - 利冲报告'},},
                    {path: 'step3',name: 'litigationStep3', component:project.create.litigation.step3,meta:{title:companyName+' - 新建案件 - 完善信息'},},
                  ],
                },
              ],
            },
          ],
        },
        //审批中心路由
        {
          path:'/approval',
          component:approval.mdPage,
          children:[
            {path:'submission',name:'approvalSubmission',component:approval.submission,meta:{title:companyName+' - 审批中心 - 我发起的'},},
            {path:'handle',name:'approvalHandle',component:approval.handle,meta:{title:companyName+' - 审批中心 - 我审批的'},},
            {path:'forwarding',name:'approvalForwarding',component:approval.forwarding,meta:{title:companyName+' - 审批中心 - 我抄送的'},},
          ],
        },
        //设置板块路由
        {
          path:'/setting',
          component:nullPage,
          children:[
            {path:'basic',name:'settingBasic',component:setting.basic,meta:{title:companyName+' - 设置 - 基础信息'},},
            {path:'notice',name:'settingNotice',component:setting.notice,meta:{title:companyName+' - 设置 - 律所公告'},},
            {
              path:'purview',
              component:setting.purview.mdPage,
              children:[
                {path:'group',name:'purviewGroup',component:setting.purview.group,meta:{title:companyName+' - 设置 - 权限设置'},},
                {path:'project',name:'purviewProject',component:setting.purview.project,meta:{title:companyName+' - 设置 - 权限设置'},},
                {path:'role',name:'purviewRole',component:setting.purview.role,meta:{title:companyName+' - 设置 - 权限设置'},},
              ]
            },
            {
              path:'approval',
              component:nullPage,
              children:[
                {path:'modelList',name:'approvalModelList',component:setting.approval.modelList,meta:{title:companyName+' - 设置 - 审批设置'},},
                {path:'list',name:'approvalList',component:setting.approval.list,meta:{title:companyName+' - 设置 - 审批设置'},},
                {path:'typeList',name:'approvalTypeList',component:setting.approval.typeList,meta:{title:companyName+' - 设置 - 审批设置'},},
                {path:'create',name:'approvalCreate',component:setting.approval.create,meta:{title:companyName+' - 设置 - 新建审批'},},
              ]
            },
            {
              path:'template',
              component:setting.template.mdPage,
              children:[
                {path:'project',name:'templateProject',component:setting.template.project,meta:{title:companyName+' - 设置 - 模板设置'},},
                {path:'create',name:'templateCreate',component:setting.template.create,meta:{title:companyName+' - 设置 - 创建模板'},},
              ]
            },
          ],
        },
        //数据中心路由
        {
          path:'/data',
          component:nullPage,
          children:[
            {path:'member',name:'dataMember',component:data.member,meta:{title:companyName+' - 数据中心 - 成员统计'},},
            {path:'financial',name:'dataFinancial',component:data.financial,meta:{title:companyName+' - 数据中心 - 资金统计'},},
            {path:'project',name:'dataProject',component:data.project,meta:{title:companyName+' - 数据中心 - 项目统计'},},
            {path:'customer',name:'dataCustomer',component:data.customer,meta:{title:companyName+' - 数据中心 - 客户名录'},},
            {path:'tracking',name:'dataTracking',component:data.tracking,meta:{title:companyName+' - 数据中心 - 资金跟踪'},},
            {path:'networkDisk',name:'networkDisk',component:data.networkDisk,meta:{title:companyName+' - 数据中心 - 律所网盘'},},
          ],
        },
        //档案中心路由
        {
          path:'/archives',
          component:nullPage,
          children:[
            {path:'search',name:'archivesSearch',component:archives.search,meta:{title:companyName+' - 档案中心 - 搜索'},},
            {path:'list',name:'archivesList',component:archives.list,meta:{title:companyName+' - 档案中心 - 档案详情'},},
          ],
        },
        //法律大数据路由
        {path:'/bigData',name:'bigData',component:bigData.mdPage,meta:{title:companyName+' - 法律大数据'}},
        //知识中心路由
        {path:'/knowledge',name:'knowledge',component:knowledge.mdPage,meta:{title:companyName+' - 知识中心'}},
      ],
    },
    {path: '/login', name: 'login', component: login,meta:{title:companyName+'互联网律所 - 登录'},},
    {path: '/register', name: 'register', component: register,meta:{title:companyName+'互联网律所 - 注册'},},
    {path: '/password', name: 'password', component: password,meta:{title:companyName+'互联网律所 - 修改密码'},},

  ]
})
